export { default as productResearchImg } from './product_research.webp';
